import { extractTextContent } from '@bedrock/core/contentful';
import { type FormField } from 'lib/contentful/types';

export const getFieldByType = (
  fields: FormField[],
  type: FormField['type'],
): FormField | undefined => {
  return fields.find((f) => f.type === type);
};

export const getLabel = (field: FormField | undefined): string => {
  if (!field?.label) return '';
  return extractTextContent(field.label);
};
